import Vue from 'vue'
import Vuex from 'vuex'
import {RepositoryFactory} from "./repositories/RepositoryFactory";
import TestRepository from "./repositories/TestRepository";
import AttempRepository from "./repositories/AttempRepository";
import AdminTestRepository from "./repositories/AdminTestRepository";
const courses = [{
    id: 'f74825e4-d0e2-4068-8011-c00e7a8eeaa8',
    title: 'Certificación ONiAd',
    slug: 'certificacion-oniad',
    shortDescription: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aperiam, dolore est hic nam natus non qui\n' +
        '              repellendus sequi tenetur vero. Ad cupiditate deserunt ea id, possimus praesentium sed tempora\n' +
        '              veritatis.',
    description: '¡Bienvenido al curso de certificación ONiAd! Aquí aprenderás todo sobre nuestra tecnología, además de consejos muy importantes para mejorar tus campañas de publicidad.' +
    '           Al final del curso podrás acceder a un test para obtener la certificación ONiAd.<br>' +
    '           <strong>¡Descubre ya las ventajas de la publicidad digital!</strong>',
    nav: [
        {
            "id": "0",
            "text": "Introducción",
            "data": {
                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/0_introduccion.md",
                "slug": "introduccion"
            }
        },
        {
            "id": "1",
            "text": "1. Conceptos básicos de ONiAd",
            "data": {
                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_conceptos_basicos_de_oniad.md",
                "slug": "1-conceptos-basicos-de-oniad",
            },
            "children": [{
                "id": "11",
                "text": "1.1. Fundamentos de publicidad digital",
                "data": {
                    "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_1_fundamentos_de_publicidad_digital.md",
                    "slug": "11-fundamentos-de-publicidad-digital",
                },
                "children": [{
                    "id": "111",
                    "text": "1.1.1. Impresiones",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_1_1_impresiones.md",
                        "slug": "111-impresiones"
                    },
                }, {
                    "id": "112",
                    "text": "1.1.2. Modelos de coste",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_1_2_modelos_de_coste.md",
                        "slug": "112-modelos-de-coste"
                    },
                }, {
                    "id": "113",
                    "text": "1.1.3. Inventario publicitario",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_1_3_inventario_publicitario.md",
                        "slug": "113-inventario-publicitario"
                    },
                }]
            }, {
                "id": "12",
                "text": "1.2. Publicidad programática",
                "data": {
                    "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_2_publicidad_programatica.md",
                    "slug": "12-publicidad-programatica",
                },
                "children": [{
                    "id": "121",
                    "text": "1.2.1. El sistema de subastas",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_2_1_sistema_de_subastas.md",
                        "slug": "121-el-sistema-de-subastas"
                    },
                }, {
                    "id": "122",
                    "text": "1.2.2. Las pujas",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_2_2_las_pujas.md",
                        "slug": "122-las-pujas"
                    }
                }]
            }, {
                "id": "13",
                "text": "1.3. Qué es ONiAd y qué ventajas aporta",
                "data": {
                    "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_3_que_es_oniad_y_que_ventajas_aporta.md",
                    "slug": "13-que-es-oniad-y-que-ventajas-aporta",
                },
                "children": [{
                    "id": "131",
                    "text": "1.3.1. ¿Qué hace ONiAd?",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_3_1_que_hace_oniad.md",
                        "slug": "131-que-hace-oniad"
                    },
                }, {
                    "id": "132",
                    "text": "1.3.2. ¿A quién se dirige?",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_3_2_a_quien_esta_dirigida.md",
                        "slug": "132-a-quien-se-dirige"
                    },
                }, {
                    "id": "133",
                    "text": "1.3.3. Beneficios que aporta ONiAd",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_3_3_beneficios_que_aporta_oniad.md",
                        "slug": "133-beneficios-que-aporta-oniad"
                    },
                }, {
                    "id": "134",
                    "text": "1.3.4. ¿Qué diferencia a ONiAd de otras tecnologías?",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_3_4_que_diferencia_a_oniad.md",
                        "slug": "134-que-diferencia-a-oniad-de-otras-tecnologias"
                    },
                }, {
                    "id": "135",
                    "text": "1.3.5. Características diferenciales",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/1_3_5_caracteristicas_diferenciales.md",
                        "slug": "135-caracteristicas-diferenciales"
                    },
                }]
            }]
        },
        {
            "id": "2",
            "text": "2. Cómo funciona ONiAd",
            "data": {
                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_como_funciona_oniad.md",
                "slug": "2-como-funciona-oniad",
            },
            "children": [{
                "id": "21",
                "text": "2.1. Anuncios",
                "data": {
                    "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_1_Anuncios.md",
                    "slug": "21-anuncios",
                },
                "children": [{
                    "id": "211",
                    "text": "2.1.1. ¿Cuáles son los requisitos del contenido de los anuncios?",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_1_1_requisitos_de_los_anuncios.md",
                        "slug": "211-cuales-son-los-requisitos-del-contenido-de-los-anuncios"
                    },
                }, {
                    "id": "212",
                    "text": "2.1.2. Cómo diseñar anuncios",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_1_2_como_dise%C3%B1ar_anuncios.md",
                        "slug": "212-como-disenar-anuncios"
                    },
                }, {
                    "id": "213",
                    "text": "2.1.3. Adaptar anuncios a cada campaña",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_1_3_adaptar_anuncios_a_cada_campa%C3%B1a.md",
                        "slug": "213-adaptar-anuncios-a-cada-campana"
                    },
                }]
            },
                {
                    "id": "22",
                    "text": "2.2. Medios",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_2_medios.md",
                        "slug": "22-medios",
                    },
                    "children": [{
                        "id": "221",
                        "text": "2.2.1. Cómo crear listas de medios",
                        "data": {
                            "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_2_1_como_crear_listas_de_medios.md",
                            "slug": "221-como-crear-listas-de-medios"
                        },
                    }, {
                        "id": "222",
                        "text": "2.2.2. Cómo elegir los medios",
                        "data": {
                            "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_2_2_como_elegir_medios.md",
                            "slug": "222-como-elegir-los-medios"
                        }
                    }]
                }, {
                    "id": "23",
                    "text": "2.3. Audiencias",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2-3_audiencias.md",
                        "slug": "23-audiencias",
                    },
                    "children": [{
                        "id": "231",
                        "text": "2.3.1. Crear audiencias de visitantes de la web",
                        "data": {
                            "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_3_1_crear_audiencia_de_visitantes_de_una-web.md",
                            "slug": "231-crear-audiencias-de-visitantes-de-la-web"
                        },
                    }, {
                        "id": "232",
                        "text": "2.3.2. Crear audiencias para envíos de email",
                        "data": {
                            "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_3_2_crear_audiencias_para_envios_de_emails.md",
                            "slug": "232-crear-audiencias-para-envios-de-email"
                        },
                    }, {
                        "id": "233",
                        "text": "2.3.3. Filtrar audiencias",
                        "data": {
                            "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_3_3_filtrar_audiencias.md",
                            "slug": "233-filtrar-audiencias"
                        }
                    }]
                }, {
                    "id": "24",
                    "text": "2.4. Geolocalización",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/2_4_geolocalizacion.md",
                        "slug": "24-geolocalizacion"
                    }
                }]
        },
        {
            "id": "3",
            "text": "3. Creación de campañas",
            "data": {
                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_creacion_de_campa%C3%B1as.md",
                "slug": "3-creacion-de-campanas",
            },
            "children": [
                {
                    "id": "31",
                    "text": "3.1. Campañas de prospección",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_1_campa%C3%B1as_de_prospeccion.md",
                        "slug": "31-campanas-de-prospeccion"
                    },
                    "children": [
                        {
                            "id": "311",
                            "text": "3.1.1 Establecer la información básica",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_1_1_establecer_la_informacion_basica.md",
                                "slug": "311-establecer-la-informacion-basica"
                            },
                        },
                        {
                            "id": "312",
                            "text": "3.1.2 Ajustar la geolocalización",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_1_2_ajustar_la_geolocalizacion.md",
                                "slug": "312-ajustar-la-geolocalizacion"
                            },
                        },
                        {
                            "id": "313",
                            "text": "3.1.3 Seleccionar los medios",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_1_3_seleccionar_los_medios.md",
                                "slug": "313-seleccionar-los-medios"
                            },
                        },
                        {
                            "id": "314",
                            "text": "3.1.4 Subir los anuncios",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_1_4_subir_los_anuncios.md",
                                "slug": "314-subir-los-anuncios"
                            },
                        },
                    ]
                },
                {
                    "id": "32",
                    "text": "3.2. Campañas de retargeting web",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_2_campa%C3%B1as_de_retargeting_para_visitantes_de_la_web.md",
                        "slug": "32-campanas-de-retargeting-web"
                    },
                    "children": [
                        {
                            "id": "321",
                            "text": "3.2.1 Establecer la información básica de la campaña",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_2_1_establecer_la_informacion_basica_de_la_campa%C3%B1a.md",
                                "slug": "321-establecer-la-informacion-basica-de-la-campana"
                            },
                        },
                        {
                            "id": "322",
                            "text": "3.2.2 Seleccionar la audiencia de la campaña",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_2_2_seleccionar_la_audiencia_de_la_campa%C3%B1a.md",
                                "slug": "322-seleccionar-la-audiencia-de-la-campana"
                            },
                        },
                        {
                            "id": "323",
                            "text": "3.2.3 Ajustar la geolocalización",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_2_3_ajustar_la_geolocalizacion.md",
                                "slug": "323-ajustar-la-geolocalizacion"
                            },
                        },
                        {
                            "id": "324",
                            "text": "3.2.4 Seleccionar los medios",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_2_4_seleccionar_los_medios.md",
                                "slug": "324-seleccionar-los-medios"
                            },
                        },
                        {
                            "id": "325",
                            "text": "3.2.5 Subir los anuncios",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_2_5_subir_los_anuncios.md",
                                "slug": "325-subir-los-anuncios"
                            },
                        },
                    ]
                },
                {
                    "id": "33",
                    "text": "3.3. Campañas de retargeting email",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_3_campañas_de_retargeting_para_email.md",
                        "slug": "33-campanas-de-retargeting-email"
                    },
                    "children": [
                        {
                            "id": "331",
                            "text": "3.3.1 Establecer la información básica de la campaña",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_3_1_establecer_la_informacion_basica.md",
                                "slug": "331-establecer-la-informacion-basica-de-la-campana"
                            },
                        },
                        {
                            "id": "333",
                            "text": "3.3.3 Seleccionar la audiencia de la campaña",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_3_3_seleccionar_la_audiencia_de_la_campa%C3%B1a.md",
                                "slug": "333-seleccionar-la-audiencia-de-la-campana"
                            },
                        },
                        {
                            "id": "333",
                            "text": "3.3.3 Ajustar la geolocalización",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_3_3_ajustar_la_geolocalizacion.md",
                                "slug": "333-ajustar-la-geolocalizacion"
                            },
                        },
                        {
                            "id": "334",
                            "text": "3.3.4 Seleccionar los medios",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_3_4_seleccionar_los_medios.md",
                                "slug": "334-seleccionar-los-medios"
                            },
                        },
                        {
                            "id": "335",
                            "text": "3.3.5 Subir los anuncios",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/3_3_5_publicar_los_anuncios.md",
                                "slug": "335-subir-los-anuncios"
                            },
                        },
                    ]
                }]
        },
        {
            "id": "4",
            "text": "4. Optimización de las campañas",
            "data": {
                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_optimizacion_de_las_campa%C3%B1as.md",
                "slug": "4-optimizacion-de-las-campanas",
            },
            "children": [
                {
                    "id": "41",
                    "text": "4.1. Métricas importantes",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_1_metricas_importantes.md",
                        "slug": "41-metricas-importantes"
                    },
                    "children": [
                        {
                            "id": "411",
                            "text": "4.1.1 Impresiones",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_1_1_impresiones.md",
                                "slug": "411-impresiones"
                            },
                        },
                        {
                            "id": "412",
                            "text": "4.1.2 CPM",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_1_2_cpm.md",
                                "slug": "412-cpm"
                            },
                        },
                        {
                            "id": "413",
                            "text": "4.1.3 Clics",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_1_3_clics.md",
                                "slug": "413-clics"
                            },
                        },
                        {
                            "id": "414",
                            "text": "4.1.4 CTR",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_1_4_ctr.md",
                                "slug": "414-ctr"
                            },
                        },
                        {
                            "id": "415",
                            "text": "4.1.5 CPC",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_1_5_cpc.md",
                                "slug": "415-cpc"
                            },
                        },
                        {
                            "id": "416",
                            "text": "4.1.6 Coste",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_1_6_coste.md",
                                "slug": "416-coste"
                            },
                        },
                    ]
                },
                {
                    "id": "42",
                    "text": "4.2. Cómo consultar las métricas de ONiAd",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_2_como_consultar_las_metricas_de_oniad.md",
                        "slug": "42-como-consultar-las-metricas-de-oniad"
                    },
                    "children":[
                        {
                            "id": "421",
                            "text": "4.2.1 Cómo consultar las métricas en Google Analytics",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_2_1_como+_ver_campa%C3%B1as_oniad_en_google_analytics.md",
                                "slug": "421-como-consultar-las-metricas-en-gooogle-analytics"
                            },
                        },
                        {
                            "id": "422",
                            "text": "4.2.2 Cómo ver las métricas de los dominios",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_2_2_como_ver_las_metricas_de_los_dominios.md",
                                "slug": "422-como-ver-las-metricas-de-los-dominios"
                            },
                        },
                        {
                            "id": "423",
                            "text": "4.2.3 Cómo ver las métricas de los anuncios",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_2_3_como_ver_metricas_de_anuncios.md",
                                "slug": "422-como-ver-las-metricas-de-los-anuncios"
                            },
                        },
                    ]
                },
                {
                    "id": "43",
                    "text": "4.3. Discrepancias entre clics y visitas",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_3_discrepaciancias_entre_clics_y_visitas.md",
                        "slug": "43-discrepancias-entre-clics-y-visitas"
                    },
                    "children":[
                        {
                            "id": "431",
                            "text": "4.3.1 ¿Cuánta discrepancia deberían tener mis anuncios?",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_3_1_cuanta_discrepancia_deberian_tener_mis_anuncios.md",
                                "slug": "421-cuanta-discrepancia-deberian-tener-mis-anuncios"
                            },
                        },
                        {
                            "id": "432",
                            "text": "4.3.2 ¿Cómo reducir la discrepancia?",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_3_2_como_reducir_la_discrepancia.md",
                                "slug": "422-como-reducir-la-discrepancia"
                            },
                        }
                    ]
                },
                {
                    "id": "44",
                    "text": "4.4. ¿Cómo mejorar el CTR%?",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/4_4_como_mejorar_el_ctr.md",
                        "slug": "44-como-mejorar-el-ctr"
                    }
                }
            ]
        },
        {
            "id": "5",
            "text": "5. Otros aspectos y funcionalidades de ONiAd",
            "data": {
                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_otros_aspectos_y_funcionalidades.md",
                "slug": "5-otros-aspectos-y-funcionalidades-de-oniad",
            },
            "children": [
                {
                    "id": "51",
                    "text": "5.1. Informes",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_1_informes.md",
                        "slug": "51-informes"
                    },
                    "children":[
                        {
                            "id": "511",
                            "text": "5.1.1. Exportar informes",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_1_1_exportar_informes.md",
                                "slug": "511-exportar-informes"
                            },
                        },
                        {
                            "id": "512",
                            "text": "5.1.2. Programar informes",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_1_2_programar_informes.md",
                                "slug": "512-programar-informes"
                            },
                        }
                    ]
                },
                {
                    "id": "52",
                    "text": "5.2. Pagos",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_2_pagos.md",
                        "slug": "52-pagos"
                    },
                    "children":[
                        {
                            "id": "521",
                            "text": "5.2.1. Formas de pago",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_2_1_formas_de_pago.md",
                                "slug": "521-formas-de-pago"
                            },
                        },
                        {
                            "id": "522",
                            "text": "5.2.2. Facturas",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_2_2_facturas.md",
                                "slug": "522-facturas"
                            },
                        }
                    ]
                },
                {
                    "id": "53",
                    "text": "5.3. Gestión de agencias",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_3_gestion_de_agencias.md",
                        "slug": "53-gestion-de-agencias"
                    },
                    "children":[
                        {
                            "id": "531",
                            "text": "5.3.1. Programa de partners",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_3_1_programa_de_partners.md",
                                "slug": "531-programa-de-partners"
                            },
                        },
                        {
                            "id": "532",
                            "text": "5.3.2. Vincular y desvincular agencias",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_3_2_vincular_y_desvincular_agencias.md",
                                "slug": "532-vincular-y-desvincular-agencias"
                            },
                        }
                    ]
                },
                {
                    "id": "54",
                    "text": "5.4. Programa de afiliados",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_4_programa_de_afiliados.md",
                        "slug": "54-programa-de-afiliados"
                    },
                    "children":[
                        {
                            "id": "541",
                            "text": "5.4.1. Ventajas del programa de afiliados",
                            "data": {
                                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/5_4_1_ventajas_del_programa_de_afiliados.md",
                                "slug": "541-ventajas-del-programa-de-afilidos"
                            },
                        }
                    ]
                }
            ]
        },
        {
            "id": "6",
            "text": "6. Preguntas frecuentes (FAQ)",
            "data": {
                "slug": "6-preguntas-frecuentes-faq",
                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/6_preguntas_frecuentes.md"
            },
            children:[
                {
                    "id": "6.1",
                    "text": "6.1. Cuestiones generales",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/6_1_cuestiones_generales.md",
                        "slug": "6-1-cuestiones-generales"
                    },
                },
                {
                    "id": "6.2",
                    "text": "6.2. Audiencias",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/6_2_audiencias.md",
                        "slug": "6-2-audiencias"
                    },
                },
                {
                    "id": "6.3",
                    "text": "6.3. Anuncios",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/6_3_anuncios.md",
                        "slug": "6-3-anuncios"
                    },
                },
                {
                    "id": "6.4",
                    "text": "6.4. Medios",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/6_4_medios.md",
                        "slug": "6-4-medios"
                    },
                },
                {
                    "id": "6.5",
                    "text": "6.5. Geolocalización",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/6_5_geolocalizacion.md",
                        "slug": "6-5-geolocalizacion"
                    },
                },
                {
                    "id": "6.6",
                    "text": "6.6. Campañas",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/6_6_campa%C3%B1as.md",
                        "slug": "6-6-campanas"
                    },
                },
                {
                    "id": "6.7",
                    "text": "6.7. Pagos y facturas",
                    "data": {
                        "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/6_7_pagos_y_facturas.md",
                        "slug": "6-7-pagos-y-facturas"
                    },
                },
            ]
        },
        {
            "id": "7",
            "text": "7. Conclusión",
            "data": {
                "slug": "7-conclusion",
                "url": "https://oniad-academy.s3-eu-west-1.amazonaws.com/themes/7_conclusion.md"
            },
        }
    ]
}];
Vue.use(Vuex);
const UserRepository = RepositoryFactory.get('user');
const CustomThemesRepository = RepositoryFactory.get('customThemes');
let themeList= [];
export default new Vuex.Store({
    state: {
        isMenuOpen: false,
        menuHasContent: false,
        courses: courses,
        testEnd: false,
        user: null,
        test: null,
        attemp: null
    },
    mutations: {
        openMenu(state, payload) {
            state.isMenuOpen = payload.state;
        },
        closeMenu(state, payload) {
            state.isMenuOpen = payload.state;
        },
        pushCourses(state, payload) {
            state.courses = [];
            state.courses = payload.courses;
        },
        endTest(state, payload) {
            state.testEnd = payload.ended;
        },
        setUser(state, payload) {
            state.user = payload.user;
        },
        setTest(state, payload) {
            state.test = payload.test;
        },
        setAttemp(state, payload) {
            state.attemp = payload.attemp;
        }
    },
    actions: {
        getCourses(context) {
            return new Promise(() => {
                context.commit({type: 'pushCourses', courses: courses})
            })

        },
        getCourse(context, payload) {
            let course = courses.find((c) => {
                return c.slug === payload.slug
            });
            themeList = [];
            course.themes = getChildren(course.nav);
            return course;
        },
        async getTheme(context,payload){
             return await findInMenu(courses[0].nav, payload.slug);
        },
        async getContentData(context, payload) {
            let theme = findInMenu(courses[0].nav, payload.slug);
            if (!theme.data.url.length){
                alert('Aqui no hay info');
                return false;
            }
            let {data} = await CustomThemesRepository.get(theme.data.url);
            return data;
            // return courses.find((c)=>{return c.id === payload.id});
        },
        toggleMenu(context) {
            if (context.state.isMenuOpen) {
                context.commit({type: 'openMenu', state: false});
            } else {
                context.commit({type: 'closeMenu', state: true});
            }
        },
        //User
        async getUser(context, payload) {
            try {
                let {data} = await UserRepository.get(payload.id);
                context.commit({type: 'setUser', user: data});
                return data
                // return user;
            } catch (e) {
                if (e.status === 400)
                    throw e;
                throw e
            }
        },
        async getUserByEmail(context, payload) {
            try {
                let {data} = await UserRepository.getByEmail(payload.data);
                // context.commit({type: 'setUser', user: data});
                return data
                // return user;
            } catch (e) {
                if (e.status === 404){
                    throw e;
                }
                throw e
            }
        },
        async postUser(context, payload) {
            try {
                const {data} = await UserRepository.post(payload.data);
                return data;
            } catch (e) {
                if (e.status === 404)
                    throw "Error";
                throw "Error"
            }
        },
        async patchUser(context, payload) {
            try {
                const {data} = await UserRepository.patch(payload.data);
                return data;
            } catch (e) {

                if (e.status === 404)
                    throw "Error";
                throw "Error"
            }
        },
        async  postUserSendEmail(context, payload) {
            try {
                const {data} = await UserRepository.postSendEmail(payload.data);
                return data;
            } catch (e) {
                throw "Error"
            }
        },
        async getTest(context, payload) {
            try {
                let {data} = await TestRepository.get(payload.data);
                context.commit({type: 'setTest', test: data});
                return data
                // return user;
            } catch (e) {
                if (e.status === 404){
                    throw e;
                }
                throw e
            }
        },
        async postAdminTest(context, payload) {
            try {
                let {data} = await AdminTestRepository.post(payload.data);
                // context.commit({type: 'setUser', user: data});
                return data
                // return user;
            } catch (e) {
                if (e.status === 404){
                    throw e;
                }
                throw e
            }
        },
        async postAttemp(context, payload) {
            try {
                let {data} = await AttempRepository.post(payload.data);
                context.commit({type: 'setAttemp', attemp: data});
                return data
                // return user;
            } catch (e) {
                if (e.status === 404){
                    throw e;
                }
                throw e
            }
        },
        async patchAttemp(context, payload) {
            try {
                let {data} = await AttempRepository.patch(payload.data);
                // context.commit({type: 'setAttemp', attemp: data});
                return data
                // return user;
            } catch (e) {
                if (e.status === 404){
                    throw e;
                }
                throw e
            }
        },
        async getAttemp(context, payload) {
            try {
                let {data} = await AttempRepository.get(payload.data);
                // context.commit({type: 'setAttemp', attemp: data});
                return data
                // return user;
            } catch (e) {
                if (e.status === 404){
                    throw e;
                }
                throw e
            }
        },
        async getAttemps(context, payload) {
            try {
                let {data} = await AttempRepository.getAttemps(payload.data);
                // context.commit({type: 'setAttemp', attemp: data});
                return data
                // return user;
            } catch (e) {
                if (e.status === 404){
                    throw e;
                }
                throw e
            }
        },
        async getCertificate(context, payload) {
            try {
                let {data} = await AttempRepository.getCertificate(payload.data);
                // context.commit({type: 'setAttemp', attemp: data});
                return data
                // return user;
            } catch (e) {
                if (e.status === 404){
                    throw e;
                }
                throw e
            }
        },
    }
})
// const themeList = [];

function getChildren(children) {

    for (let i = 0; i < children.length; i++) {
        if (children[i].children && children[i].children.length) {
            themeList.push({id: children[i].id, text: children[i].text,data:{slug:children[i].data.slug}});
            getChildren(children[i].children);
        } else {
            themeList.push({id: children[i].id, text: children[i].text,data:{slug:children[i].data.slug}});
        }
    }

    return themeList;
}

function findInMenu(nav,search){
    let element;
    for (let i = 0; i < nav.length; i++){
        element = searchelement(nav[i],search  );
        if (element !== null){

            return element;
        }
    }
    return null;
}
const searchelement = (tree, target) => {
    if (tree.data && tree.data.slug === target) {
        return tree;
    }
    if (!tree.children){return null;}
    for (const child of tree.children) {
        const res = searchelement(child, target);

        if (res) {
            return res;
        }
    }
    return null;
};


// Esto es por que los datos si que se sacarán de DB pero el nav y el id lo tenemos hardcodeado hasta que haya más cursos y un listado para elegir el curso

